import React, { useContext } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import * as R from 'ramda';
import { bool } from 'prop-types';
import { useUserRolePermissions } from 'hooks';
import renderInput from './renderUtils';
import { CreateReconsignmentContext } from '../Create';
import { useGetProductOriginsQuery } from '../../reconsignmentsEndpoints';

const renderTags = (tags, getTagProps) =>
  tags.map((item, index) => (
    <Chip
      label={item.originName}
      sx={{ borderColor: 'secondary.main', borderRadius: 25 }}
      variant="outlined"
      {...getTagProps({ index })}
    />
  ));

const BulkFilters = ({ isLoading }) => {
  const { filters, info, setFilters, setInfo } = useContext(CreateReconsignmentContext);
  const { currentAffiliate } = useUserRolePermissions();

  const params = {
    inventoryOwner: {
      companyCustomerIdName: currentAffiliate?.customerIdName,
      dataCompanyId: currentAffiliate?.dataCompanyId,
    },
    productId: R.path(['product', 'productId'], info),
  };

  const { data = [], isFetching } = useGetProductOriginsQuery(
    { params },
    { skip: R.or(R.isNil(currentAffiliate), R.isNil(R.prop('product', info))) }
  );

  const handleChangeInfo = () =>
    setInfo(
      R.evolve(
        {
          fromLocations: R.always([]),
          souceLocations: R.always([]),
          toLocations: R.always([]),
        },
        info
      )
    );

  return (
    <Stack style={{ marginTop: 0 }} sx={{ mt: 0, pb: 2, px: 2 }}>
      <Autocomplete
        disabled={R.or(isLoading, R.isNil(R.prop('product', info)))}
        getOptionLabel={o => R.defaultTo('', R.prop('originName', o))}
        isOptionEqualToValue={R.eqProps('originId')}
        label="Origins"
        limitTags={10}
        loading={isFetching}
        multiple
        onChange={(_, val) => {
          setFilters(R.assoc('origins', val, filters));
          handleChangeInfo();
        }}
        options={data}
        renderInput={renderInput('Origins')}
        renderTags={renderTags}
        value={R.prop('origins', filters)}
      />
    </Stack>
  );
};

BulkFilters.propTypes = {
  isLoading: bool.isRequired,
};

export default BulkFilters;
